import { t } from "i18next"
import { useGetRelatedCustomers } from "@/domains/visualization/hooks/useGetRelatedCustomers"
import { selectRootCustomerId } from "@/domains/visualization/store/selectors"
import { useGraphStore } from "@/domains/visualization/store/store"
import { ErrorComponent } from "@/shared/components/ErrorComponent/ErrorComponent"
import { Loading } from "@/shared/components/Loading/Loading"
import { GraphContainer } from "../GraphContainer/GraphContainer"

export function Graph() {
  const rootCustomerId = useGraphStore(selectRootCustomerId)
  const query = useGetRelatedCustomers(rootCustomerId)

  if (query.isLoading) {
    return <Loading text={t("customer.overview.loadingHierarchy")} />
  }

  if (query.isError) {
    return (
      <ErrorComponent
        error={query.error}
        onRetry={(): void => {
          void query.refetch()
        }}
      />
    )
  }

  return <GraphContainer />
}
